import styled from 'styled-components';

import { pxToRem } from 'utils/scss';

export const PlaceholderWrapper = styled.div`
  min-height: ${pxToRem('300px')};
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  background: transparent;
`;
